import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';
import { computeCurrentStage } from '../state.js';
import { VARIETIES } from '../data/upgrades.js';
import { ACHIEVEMENTS as ACH_DEFS } from '../data/achievements.js';

let checkTimer = 0;

export const progressCheckSystem: TickSystem<GameState, GameAction> = {
  name: 'progressCheck',
  update: (state, dt, _dispatch) => {
    if (!state.isRunning) return state;

    checkTimer += dt;
    if (checkTimer < 1) return state; // check every second
    checkTimer = 0;

    let changed = false;
    let newState = state;

    // Stage check
    const newStage = computeCurrentStage(state.stats.totalBeans);
    if (newStage !== state.currentStage) {
      newState = { ...newState, currentStage: newStage };
      changed = true;
    }

    // Variety check
    const newVarieties: string[] = [];
    for (const v of VARIETIES) {
      if (newState.unlockedVarieties.includes(v.id)) continue;
      let unlocked = false;
      if (v.unlockType === 'beans') unlocked = newState.stats.totalBeans >= v.unlockValue;
      else if (v.unlockType === 'prestige') unlocked = newState.stats.totalPrestiges >= v.unlockValue;
      else if (v.unlockType === 'achievements') unlocked = newState.unlockedAchievements.length >= v.unlockValue;
      if (unlocked) newVarieties.push(v.id);
    }
    if (newVarieties.length > 0) {
      newState = { ...newState, unlockedVarieties: [...newState.unlockedVarieties, ...newVarieties] };
      changed = true;
    }

    // Achievement check
    const newAch: string[] = [];
    for (const ach of ACH_DEFS) {
      if (newState.unlockedAchievements.includes(ach.id)) continue;
      if (ach.check(newState)) newAch.push(ach.id);
    }
    if (newAch.length > 0) {
      let bonusGB = 0;
      for (const id of newAch) {
        const ach = ACH_DEFS.find(a => a.id === id);
        if (ach?.reward.type === 'goldenBeanFlat') bonusGB += ach.reward.amount;
      }
      newState = {
        ...newState,
        unlockedAchievements: [...newState.unlockedAchievements, ...newAch],
        goldenBeans: newState.goldenBeans + bonusGB,
      };
      changed = true;
    }

    return changed ? newState : state;
  },
};
